import Header from "../../../Components/Header";
import ActivityLogComponents from "./Components/ActivityLog-Components";
import Footer from "../../../Components/Footer";

const ActivityLog = () => {
  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Header />
      <ActivityLogComponents />
      <Footer />
    </div>
  );
};
export default ActivityLog;
